<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
        <div class="d-flex justify-space-between">
          <div>Note</div>
          <div
            class="color-palette small"
            :style="{ backgroundColor: node.bg ? node.bg : '#FFFFFF' }"
            @click="showColorPalette = !showColorPalette"
          ></div>
        </div>
        <div
          v-if="showColorPalette"
          class="box-color m-t-5 d-flex justify-space-between"
        >
          <div
            v-for="(color, index) in colors"
            :key="index"
            class="color-palette"
            :class="
              clickColor.toLowerCase() === color.bg.toLowerCase()
                ? 'selected'
                : ''
            "
            :style="{ backgroundColor: color.bg }"
            @click="handleColor(color.bg)"
          >
            <i
              v-if="clickColor.toLowerCase() === color.bg.toLowerCase()"
              class="fas fa-check"
              :style="{ color: color.text }"
            ></i>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
        <v-textarea
          class="textarea-input"
          v-model="node.note"
          placeholder="Take a note ..."
          solo
          hide-details
          :rows="rows"
          @blur="blackListCharacters"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    node: Object,
    rows: {
      type: Number,
      default: 4
    }
  },
  watch: {
    'node.note': {
      handler(value) {
        if (this.node.node === 'note') this.node.name = value ? value : 'Note'
      }
    }
  },
  data() {
    return {
      colors: this.$nodeColor,
      showColorPalette: false,
      clickColor: ''
    }
  },
  created() {
    if (!this.node.bg) {
      this.node.bg = '#FFFFFF'
    }

    this.clickColor = this.node.bg
  },
  methods: {
    handleColor(color) {
      this.node.bg = color
      this.clickColor = color
    },
    blackListCharacters() {
      const blackListRegex = /(<[^>]+>|<[^>]>|<\/[^>]+>)/gi
      this.node.note = this.node.note.replace(blackListRegex, '')
    }
  }
}
</script>

<style scoped lang="scss">
.body-dialog {
  margin: 10px !important;
}
</style>
